export default __webpack_public_path__ + "static/media/kitchen3-after3-480w.d3222d91.webp";